import { render, staticRenderFns } from "./RirsTableHeaderRow.vue?vue&type=template&id=36d82fc6&scoped=true"
import script from "./RirsTableHeaderRow.vue?vue&type=script&lang=js"
export * from "./RirsTableHeaderRow.vue?vue&type=script&lang=js"
import style0 from "./RirsTableHeaderRow.vue?vue&type=style&index=0&id=36d82fc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d82fc6",
  null
  
)

export default component.exports